var mutation = {
	//state
	setSetdata(state,{data,key}){
		state[key] = data;
	}
}
export default mutation



// WEBPACK FOOTER //
// ./src/store/modules/setting/mutation.js